function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  className: "Terminal"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#C4C4C4",
  d: "M3.16 13.678L176.993 3.032l4 106.5-174.5 10.5L3.16 13.678z",
  className: "boxFill"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M179.343 1.518c.4.363.636.872.655 1.412l3.75 107.382a2 2 0 01-1.878 2.066L6.29 122.989a2.002 2.002 0 01-2.12-1.927L.438 14.178a2 2 0 011.872-2.066L177.873 1.004a2.003 2.003 0 011.47.514zM4.503 15.982l3.593 102.89 171.587-10.369-3.61-103.377L4.503 15.982z",
  className: "boxStroke",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("g", {
  className: "TerminalShapes"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M150.931 94a2 2 0 01-1.81 2.173l-46.845 4.26a2 2 0 01-.362-3.984l46.845-4.26a2 2 0 012.172 1.81z",
  className: "line",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M40.372 33.176a2 2 0 012.79-.465l41.113 29.361-35.798 42.155a2 2 0 01-3.049-2.59L78.41 62.799 40.838 35.966a2 2 0 01-.466-2.79z",
  className: "arrow",
  clipRule: "evenodd"
})));

function SvgTerminal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 184,
    height: 124,
    fill: "none",
    viewBox: "0 0 184 124",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerminal);
export default __webpack_public_path__ + "static/media/Terminal.deec02e7.svg";
export { ForwardRef as ReactComponent };